module.exports = __webpack_public_path__ + "b0a4684ccb5f1c8ff811cff09c3b0659.jpg";